import React, { Component } from 'react';
import range from 'range';

// polyfills using core-js
import 'core-js/fn/array/find';
import 'core-js/fn/array/find-index';
import 'core-js/fn/array/some';

import question_mark_svg from './assets/question-mark.svg';
import background_layer from './assets/layers/BACKwallBLANK.png';
import control_bar_layer from './assets/layers/LOAD_CONTROLbar.png';
import panel_layer from './assets/layers/PANELtop.png';
import targets_0 from './assets/layers/3targets.png';
import targets_1 from './assets/layers/4targets.png';
import targets_2 from './assets/layers/6targets.png';
import spotlight from './assets/layers/SPOTlight.png';

import level0_button from './assets/layers/SELECTstage3.png';
import level1_button from './assets/layers/SELECTstage4.png';
import level2_button from './assets/layers/SELECTstage6.png';

import volume_on from './assets/SOUNDon.png';

// import  from './assets/layers/';

import './App.css';
import {PANEL, STAGE, GAME_STATES} from './AppConstants.js';
import {LEVELS, START_HAND_IMMEDIATELY} from './config';
import Draggable from './Draggable';
import Fader from './Fader';
import Focusable from './Focusable';
import FocusManager from './FocusManager';
import getAppCoordinates from './AppCoordinateManager.js';
import HelpButton from './HelpButton';
import InvisibleButton from './InvisibleButton';
import KeyboardHints from './KeyboardHints';
import MagnetStrobeLayer from './MagnetStrobeLayer';
import MuteButton from './MuteButton';
import PlaceHolder from './PlaceHolder';
import ProgressBar from './ProgressBar';
import _Robot, {ROBOT_VISUAL_STATES} from './Robot';
import RobotHand from './RobotHand.js';
import StageControls, {STAGE_CONTROL_BUTTONS} from './StageControls';
import {Shakeable} from './Shaker';
import Sound from './Sound';
import SuccessLayer from './SuccessLayer';
import Timer from './Timer.js';
import {onNextFrame, getRandomElement} from './utils.js';
import ZeroSizeCenterer from './ZeroSizeCenterer';

export const initial_app_images = [
  background_layer,
  control_bar_layer,
  panel_layer,
  targets_0,
  level0_button,
  volume_on,
];

const active_level_buttons = [
  level0_button,
  level1_button,
  level2_button,
];
const LEVEL_BUTTON_WIDTH = 143;
const LEVEL_BUTTON_HEIGHT = 87;
const level_button_positions = [
  {
    left: 546,
    top: 614,
  },{
    left: 691,
    top: 637,
  },{
    left: 834,
    top: 615,
  },
];
const BUTTON_INDECES = [0, 1, 2];

/*
  This approach has advantages over simply wrapping Robot in <Shaker></Shaker> when we want it to shake.
  That approach means Robots will be unmounted/remounted whenever we add/remove the Shaker wrapper.
  This approach means the wrapper is always there, the component hierarchy doesn't change,
  so the Robot will never have to re-mount.
*/
const Robot = Shakeable(_Robot);

// DEBUG
const DISABLE_HAND = false;

function array_contains(array, element) {
  return array.find(e => e === element) !== undefined;
}


const panel_indeces = [0,1,2,3,4,5,6,7,8];
const robot_indeces = [0,1,2,3,4,5,6,7,8];

function fillSequence(sequence, to_number_of_notes, with_stage_count) {
  for (var i = to_number_of_notes - sequence.length; i > 0; i--) {
    sequence.push(Math.floor(Math.random() * with_stage_count));
  }
}
function getPreparedSequence(current_sequence, level, sequence_number) {    
  var new_sequence = current_sequence.slice();
  fillSequence(new_sequence, level.notes_per_sequence[sequence_number - 1], level.stage_count);
  return new_sequence;
}

// given number of robots on stage, how many are on one row
const stage_row_widths = {
  '3' : 3,
  '4' : 3,
  '6' : 3,
};

function location_descriptions_are_equal(d1, d2) {
  return d1.area === d2.area && d1.index === d2.index;
}

function panel_focus_key(panel_index) {
  return 'panel ' + panel_index;
}
function stage_focus_key(stage_index) {
  return 'stage ' + stage_index;
}
function level_control_key(button_index) {
  return 'level button ' + button_index;
}

const panel_place_holder_half_width = 45;
function makePanelLocation(x,y) {
  return {
    center: {left:x, top:y},
    upper_left: {left:x-panel_place_holder_half_width, top:y-panel_place_holder_half_width},
    lower_right: {left:x+panel_place_holder_half_width, top:y+panel_place_holder_half_width},
  }
}
const panel_locations = [
  makePanelLocation(75,63),
  makePanelLocation(177,68),
  makePanelLocation(279,66),
  makePanelLocation(394,66),
  makePanelLocation(510,66),
  makePanelLocation(620,66),
  makePanelLocation(731,66),
  makePanelLocation(846,66),
  makePanelLocation(949,66),
];

const stage_place_holder_half_width = 90;
function makeStageLocation(x,y) {
  return {
    center: {left:x, top:y},
    upper_left: {left:x-stage_place_holder_half_width, top:y-stage_place_holder_half_width},
    lower_right: {left:x+stage_place_holder_half_width, top:y+stage_place_holder_half_width},
  }
}
const stage_locations_by_level = [
  [
    makeStageLocation(307,398),
    makeStageLocation(517,448),
    makeStageLocation(746,399),
  ],
  [
    makeStageLocation(312,278),
    makeStageLocation(523,245),
    makeStageLocation(737,300),
    makeStageLocation(514,471),
  ],
  [
    makeStageLocation(290,276),
    makeStageLocation(495,286),
    makeStageLocation(697,283),
    makeStageLocation(291,503),
    makeStageLocation(500,492),
    makeStageLocation(698,490),
  ],
];
const stage_images = [
  targets_0,
  targets_1,
  targets_2,
];


// sub-states of REPEATING_SEQUENCE
// we could be in any one of these states for any given note in the sequence
const REPEATING_STATES = {
  // Note number is the one the user should hit
  WAITING_FOR_INPUT: 'waiting',
  // Note number is the one the user just hit
  // Make robot sing
  // Go immediately to indicating success
  STARTING_NOTE: 'starting note',
  // Note number is the one the user just hit
  // On sound complete, advance note number and go to WAITING_FOR_INPUT
  // On successful selection (which is the NEXT note number), advance note number and go to STARTING_NOTE
  INDICATING_SUCCESS: 'indicating success',
}

const PLAYING_STATES = {
  PAUSED_BEFORE_STARTING_SEQUENCE: 'paused before starting sequence',
  STARTING_NOTE: 'starting note',
  ENDING_NOTE: 'ending note',
};

const HELPING_HAND_STATES = {
  // help button not on screen, hand not on screen
  NONE: 'none',
  // help button has appeared, indicating that help is available, but user has not yet clicked it
  AVAILABLE: 'available',

  /*
    These represent the various sequences the hand performs.
    Most of these states could be replace by a general "active" flag,
    and other app state properties could be used to determine which 
    help sequence is active. However, there are a few app states which 
    could actually be showing different help sequences, so we just 
    give each sequence a separate flag to be safe.
  */
  MOVE_ROBOT: 'move robot',
  PRESS_PLAY: 'press play',
  TAP_CORRECT_ROBOT: 'tap correct robot',
  TAP_RESET_BUTTON: 'tap reset button',
  TAP_NEXT_LEVEL: 'tap next level',
};

const FOCUS_ROWS = {
  PANEL: 0,
  // 1.x reserved for stage
  // 1.0 -> stage 1
  // 1.1 -> stage 2
  HELP_BUTTON: 1.0,
  MUTE_CONTROLS: 1.0,
  PLAYBACK_CONTROLS: 1.1,
  LEVEL_CONTROLS: 4,
};
function stage_focus_row(stage_row) {
  return 1 + stage_row/10;
}

class App extends Component {
  constructor(props) {
    super(props);

    this.focusManager = new FocusManager((focused_item_key) => this.setState({focused_item_key}));
    this.level_buttons = [];

    this.state = {
      is_first_time_in_filling_stage_phase: START_HAND_IMMEDIATELY,

      muted: false,

      // for keyboard navigation
      focused_item_key: null,

      game_state: GAME_STATES.FILLING_STAGE,

      magnet_strobe_index: 0,

      level_index: 0,
      // which note in the current sequence are we playing. 1 - X
      // Used during both playing and repeating stages
      note_number: null,
      // which sequence in the current level are we playing. 1 - Y
      sequence_number: null,
      // array of stage indeces for the notes in the current sequence
      // grows with every sequence
      current_sequence: null,

      // during PLAYING_SEQUENCE, this must be one of the PLAYING_STATES
      playing_state: null,

      // during REPEATING_SEQUENCE, this must be one of the REPEATING_STATES
      repeating_state: null,

      /*
        'location' here is a poor choice of words.
        This is really a description of where the robot is, relative to other elements.
        It describes which placeholder (in PANEL or STAGE) each Robot is tied to.
      */
      robot_locations: robot_indeces.map(robot_index => ({
        area: PANEL,
        index: robot_index,
      })),
      selected_robot: null,

      // if a robot is being dragged over a PlaceHolder and is ready to be dropped,
      // this identifies that PlaceHolder 
      hovered_placeholder: null,

      // all help/helping hand state properties will begin with "hand_"
      // we won't initialize them all here - we'll just set them as needed
      hand_state: HELPING_HAND_STATES.NONE,
      /*
        this is used to help reset the timer when switching between two states
        which both render the same timer (ie. when switching levels while in 
        filling stage phase). In those cases, increment this counter to ensure
        the timer is reset
      */
      hand_timeout_counter: 0,
    };

    // See focusable_function for usage.
    this.focus_functions = {}
  }
  shows_keyboard_focus() {
    switch (this.state.hand_state) {
      case HELPING_HAND_STATES.NONE:
      case HELPING_HAND_STATES.AVAILABLE:
        return true;
    }
    return false;
  }
  /*
    Helper for registering elements with focus manager.
    This must return the same function when invoked with the same parameters.
    The returned function will end up being passed to an element's ref attribute,
    and if it's not the exact same function, the element will end up being 
    de-registered and then registered again with focusManager on each render.
  */
  focusable_function(key, row_level) {
    this.focus_functions[row_level] = this.focus_functions[row_level] || {}
    this.focus_functions[row_level][key] = this.focus_functions[row_level][key] || (
      (element) => {this.focusManager.register(key, row_level, element);}
    )
    return this.focus_functions[row_level][key];
  }  
  stage_focus_function(stage_index) {
    // determine which row of stage this placeholder is in
    const {level_index} = this.state;
    const level = LEVELS[level_index];
    const robots_per_row = stage_row_widths[level.stage_count];
    const row_index = Math.floor(stage_index / robots_per_row);

    return this.focusable_function(
      stage_focus_key(stage_index),
      stage_focus_row(row_index),
    );
  }

  // programmatically click a placeholder - used for helping hand stuff
  // note - the "React way" of doing this would be to get a ref from each PlaceHolder,
  // but this works and is simpler. Just might have to updated if we update PlaceHolder 
  click_placeholder(location) {
    const container_class = location.area === PANEL ? '#App-panel-placeholders' : '#App-stage-placeholders';
    this.app_element.querySelectorAll(container_class + ' .PlaceHolder-click-target')[location.index].click();
  }

  get_stage_control_button() {
    return this.app_element.querySelector('.StageControls-button');
  }


  /////////////////////////////////////////////////////////////////////////////
  // General game control
  /////////////////////////////////////////////////////////////////////////////
  robotLocationsUpdatedForLevel(level_index) {
    const {robot_locations} = this.state;

    const stage_locations = stage_locations_by_level[level_index];
    const new_robot_locations = robot_locations.slice();
    const stage_count = stage_locations.length;

    // iterate through new_robot_locations, moving robots to panel as necessary
    for (var robot_index = new_robot_locations.length - 1; robot_index >= 0; robot_index--) {
      const location = new_robot_locations[robot_index];
      if (location.area === STAGE && location.index >= stage_count) {
        // move robot to an available panel location
        // find first panel index where no robot is in that location
        const panel_index = panel_indeces.find((panel_index) => {
          return !new_robot_locations.some((location) => (
            location.area === PANEL && location.index === panel_index
          ));
        });

        new_robot_locations[robot_index] = {area: PANEL, index: panel_index};
      }
    }
    return new_robot_locations;
  }
  select_placeholder_during_filling_stage(placeholder_descriptor) {
    const {selected_robot, robot_locations} = this.state;

    const new_robot = robot_locations.findIndex(l => location_descriptions_are_equal(l, placeholder_descriptor))

    this.restart_help_timer();

    // if the clicked a different robot, select it instead
    if (new_robot >= 0) {
      this.setState({selected_robot: new_robot});
    }
    // they clicked an empty placeholder. 
    else if (selected_robot !== null) {
      const new_locations = robot_locations.slice();
      new_locations[selected_robot] = placeholder_descriptor;
      this.setState({
        robot_locations: new_locations,
        selected_robot: null,
      });

      // if they moved a robot to stage, cancel help button - they are on the right track
      if (placeholder_descriptor.area === STAGE) {
        this.cancel_any_available_help();
      }
    }
  }

  /////////////////////////////////////////////////////////////////////////////
  // Sequence playback logic
  /////////////////////////////////////////////////////////////////////////////
  startLevel(level) {
    this.setState({selected_robot: null});
    this.startSequence(level, [], 1);
  }
  startSequence(level, current_sequence, sequence_number) {
    const new_sequence = getPreparedSequence(current_sequence, level, sequence_number);
    this.setState({
      game_state: GAME_STATES.PLAYING_SEQUENCE,
      playing_state: PLAYING_STATES.PAUSED_BEFORE_STARTING_SEQUENCE,
      current_sequence: new_sequence,
      sequence_number: sequence_number,
      note_number: 1,
    });
  }
  expectedStageIndex() {
    const {current_sequence, note_number, repeating_state} = this.state;
    if (repeating_state === REPEATING_STATES.INDICATING_SUCCESS) {
      return current_sequence[note_number];
    }
    return current_sequence[note_number - 1];
  }
  on_user_repeated_while_idle = (stage_index) => {
    this.cancel_any_available_help();
    const expected_index = this.expectedStageIndex();
    if (stage_index === expected_index) {
      this.setState({
        repeating_state: REPEATING_STATES.STARTING_NOTE,
      });
    }
    else {
      this.setState({
        game_state: GAME_STATES.FAILURE,
      });
    }
  };
  on_user_repeated_while_indicating_success = (stage_index) => {
    const {note_number} = this.state;
    this.cancel_any_available_help();
    const expected_index = this.expectedStageIndex();
    if (stage_index === expected_index) {
      this.setState({
        note_number: note_number+1,
        repeating_state: REPEATING_STATES.STARTING_NOTE,
      });
    }
    else {
      this.setState({
        game_state: GAME_STATES.FAILURE,
      });
    }
  }


  /////////////////////////////////////////////////////////////////////////////
  // Robot location management
  /////////////////////////////////////////////////////////////////////////////
  getCoordinatesOfRobotPlaceHolder(robot_index) {
    const {level_index} = this.state;

    const stage_locations = stage_locations_by_level[level_index];
    const robot_location = this.state.robot_locations[robot_index];
    const locations = robot_location.area === PANEL ? panel_locations : stage_locations;
    return locations[robot_location.index].center;
  }  
  stage_is_full(robot_locations) {
    const {level_index} = this.state;

    const stage_locations = stage_locations_by_level[level_index];
    var filled_stage_count = 0;
    robot_locations.forEach((location) => {
      if (location.area === STAGE) {
        filled_stage_count++;
      }
    });
    return filled_stage_count === stage_locations.length;
  }
  // calculate array mapping stage locations -> robot in that position (if any)
  get_stage_robots() {
    const {level_index, robot_locations} = this.state;
    const level = LEVELS[level_index];

    // initialize array of nulls
    let stage_robots = level.stage_indeces.map(index => null);

    for (let robot_index = robot_locations.length - 1; robot_index >= 0; robot_index--) {
      let location = robot_locations[robot_index];
      if (location.area === STAGE) {
        stage_robots[location.index] = robot_index;
      }
    }

    return stage_robots;
  }
  robot_for_stage_index(stage_index) {
    return this.get_stage_robots()[stage_index];
  }


  /////////////////////////////////////////////////////////////////////////////
  // Helping hand stuff
  /////////////////////////////////////////////////////////////////////////////
  create_help_timer(help_type) {
    return <Timer 
      delay={4000} 
      on_timeout={() => this.setState({hand_state: HELPING_HAND_STATES.AVAILABLE})} 
      reset_prevention_key={help_type + this.state.hand_timeout_counter}
    />
  }
  // call this after a "successful" interaction which indicates user is on right track,
  // but when the same help will ultimately be available if user pauses
  restart_help_timer() {
    const {hand_timeout_counter} = this.state;
    this.setState({hand_timeout_counter: hand_timeout_counter+1});
  }
  prepare_for_helping_hand() {
    // We might want to alter various state properties while hand is helping.
    // Here, we backup current state so we can reset it after hand is done.

    // shallow copy current state
    this.state_before_helping_hand = Object.assign({}, this.state);
    this.setState({hand_substate: 0});
  }
  cancel_helping_hand() {
    this.setState(this.state_before_helping_hand);
    this.setState({hand_state: HELPING_HAND_STATES.NONE});
    this.state_before_helping_hand = null;
  }
  make_hand_move_robot_to_stage() {
    this.prepare_for_helping_hand();

    const {level_index, robot_locations} = this.state;
    const level = LEVELS[level_index];

    // find a random robot in the panel
    const panel_robot_indeces = robot_indeces.filter(robot_index => robot_locations[robot_index].area === PANEL);
    const robot_index_to_move = getRandomElement(panel_robot_indeces);

    // find a random open stage position
    const stage_robots = this.get_stage_robots();
    const open_stage_indeces = level.stage_indeces.filter(stage_index => stage_robots[stage_index] === null);
    const stage_index_to_move_to = getRandomElement(open_stage_indeces);

    this.setState({
      'hand_state': HELPING_HAND_STATES.MOVE_ROBOT,
      'hand_should_move_robot': robot_index_to_move,
      'hand_should_move_robot_to_stage_position': stage_index_to_move_to,
    });
  }
  cancel_any_available_help() {
    // various "successful" interactions should cause the help button to disappear, if present
    // when those occur, call this method
    const {hand_state} = this.state;
    if (hand_state === HELPING_HAND_STATES.AVAILABLE) {
      this.setState({hand_state: HELPING_HAND_STATES.NONE});
    }
  }
  advance_hand = () => {
    this.setState({
      hand_substate: this.state.hand_substate+1,
    });
  }


  /////////////////////////////////////////////////////////////////////////////
  // Rendering functions
  /////////////////////////////////////////////////////////////////////////////
  getBasicRobots(error=false) {
    const {robot_locations} = this.state;
    const visual_state = error ? ROBOT_VISUAL_STATES.ERROR : ROBOT_VISUAL_STATES.DEFAULT;
    return robot_indeces.map(robot_index => <Robot
      visual_state={visual_state}
      number={robot_index+1}
      large={robot_locations[robot_index].area === STAGE}
    />);
  }

  render_hand_moving_and_clicking(final_position) {
    const {hand_substate} = this.state;

    const initial_position = {top: 225, left: 200};
    const movement_transition = 'top 1s ease-in-out, left 1s ease-in-out';
  
    if (hand_substate === 0) {
      onNextFrame(this.advance_hand);
      return <Draggable 
        draggable={false} 
        initial_coords={initial_position}
      >
        <Fader visible={false}>
          <RobotHand is_clicking={false} />
        </Fader>
      </Draggable>; 
    }
    else if (hand_substate === 1) {
      return <Draggable 
        draggable={false} 
        initial_coords={initial_position}
      >
        <Fader visible={true} on_transition_end={this.advance_hand}>
          <RobotHand is_clicking={false} />
        </Fader>
      </Draggable>; 
    }
    else if (hand_substate === 2) {
      return <Draggable 
        draggable={false} 
        initial_coords={final_position}
        transition={movement_transition}
        on_transition_end={this.advance_hand}
      >
        <Fader visible={true}>
          <RobotHand is_clicking={false} />
        </Fader>
      </Draggable>; 
    }
    else if (hand_substate === 3) {
      return <Draggable 
        draggable={false} 
        initial_coords={final_position}
      >
        <Fader visible={true}>
          <RobotHand is_clicking={true} />
        </Fader>
        <Timer
          delay={300}
          on_timeout={this.advance_hand}
          reset_prevention_key={hand_substate}
        />
      </Draggable>; 
    }
    else if (hand_substate === 4) {
      onNextFrame(this.advance_hand);
      return <Draggable 
        draggable={false} 
        initial_coords={final_position}
      >
        <Fader visible={true}>
          <RobotHand is_clicking={false} />
        </Fader>
      </Draggable>; 
    }
    else if (hand_substate === 5) {
      return <Draggable 
        draggable={false} 
        initial_coords={final_position}
      >
        <Fader visible={false} on_transition_end={() => this.setState({
          hand_state: HELPING_HAND_STATES.NONE,
          hand_substate: 0,
        })}>
          <RobotHand is_clicking={false} />
        </Fader>
      </Draggable>; 
    }
  }

  render_filling() {
    const {
      selected_robot, 
      level_index, 
      robot_locations, 
      focused_item_key,
      hand_state,
      hand_substate,
      hand_should_move_robot,
      hand_should_move_robot_to_stage_position,
      is_first_time_in_filling_stage_phase,
    } = this.state;

    if (is_first_time_in_filling_stage_phase && this.props.start_robot_hand) {
      onNextFrame(() => {
        this.setState({is_first_time_in_filling_stage_phase: false});
        this.make_hand_move_robot_to_stage();
      });
    }

    const stage_locations = stage_locations_by_level[level_index];
    const selected_placeholder = selected_robot !== null ? robot_locations[selected_robot] : null;

    const level = LEVELS[level_index];
    const stage_is_full = this.stage_is_full(robot_locations);
    const robots = robot_indeces.map(robot_index =>
      <Robot
        shaking={
          // robot_index !== selected_robot
          selected_robot === null
        }
        number={robot_index+1}
        large={robot_locations[robot_index].area === STAGE}
        should_play_sound_once={robot_index === selected_robot}
        visual_state={robot_index === selected_robot ? ROBOT_VISUAL_STATES.SINGING : ROBOT_VISUAL_STATES.DEFAULT}
        long_sound={true}
      />
    );
    const located_robots = robot_indeces.map(
      robot_index => <Draggable
        key={robot_index}

        draggable={false}

        // turn off transitions when robot is NOT being dropped by user 
        // (this only affects robot being reset after helping hand drags one to stage)
        transition={true ? undefined : 'none'}

        initial_coords={this.getCoordinatesOfRobotPlaceHolder(robot_index)}
      >
        <ZeroSizeCenterer>
          {robots[robot_index]}
        </ZeroSizeCenterer>
      </Draggable>
    );

    let help_callback = null;
    let helping_hand = null;
    let help_timeout = null;
    let state_transition_timeout = null;
    if (hand_state === HELPING_HAND_STATES.NONE) {
      if (!stage_is_full) {
        help_timeout = this.create_help_timer("robot_drag_to_stage");
      }
      else {
        help_timeout = this.create_help_timer("press play button");
      }
    }
    else if (hand_state === HELPING_HAND_STATES.AVAILABLE) {
      if (!stage_is_full) {
        help_callback = () => this.make_hand_move_robot_to_stage();
      }
      else {
        help_callback = () => this.setState({
          hand_state: HELPING_HAND_STATES.PRESS_PLAY,
          hand_substate: 0,
        });
      }
    }
    else if (hand_state === HELPING_HAND_STATES.MOVE_ROBOT) {
      // where on screen the hand should appear
      // we could also just have it move in from off-screen
      const initial_position = {top: 225, left: 200};
      const movement_transition = 'top 1s ease-in-out, left 1s ease-in-out';
      const panel_position = panel_locations[robot_locations[hand_should_move_robot].index].center;
      const stage_position = stage_locations[hand_should_move_robot_to_stage_position].center;

      if (hand_substate === 0) {
        onNextFrame(this.advance_hand);
        helping_hand = <Draggable draggable={false} initial_coords={initial_position}>
          <Fader visible={false}>
            <RobotHand />
          </Fader>
        </Draggable>;
      }
      else if (hand_substate === 1) {
        helping_hand = <Draggable draggable={false} initial_coords={initial_position}>
          <Fader visible={true} on_transition_end={this.advance_hand}>
            <RobotHand />
          </Fader>
        </Draggable>;
      }
      else if (hand_substate === 2) {
        helping_hand = <Draggable 
          draggable={false} 
          initial_coords={panel_position} 
          transition={movement_transition}
          on_transition_end={this.advance_hand}
        >
          <Fader visible={true}>
            <RobotHand />
          </Fader>
        </Draggable>; 
      }
      else if(hand_substate === 3) {
        if (selected_robot !== hand_should_move_robot) {
          onNextFrame(() => this.click_placeholder(robot_locations[hand_should_move_robot]))
        }
        else {
          state_transition_timeout = <Timer
            delay={300}
            on_timeout={this.advance_hand}
            reset_prevention_key={"move_hand_to_stage"}
          />
        }
        helping_hand = <Draggable draggable={false} initial_coords={panel_position}>
          <Fader visible={true}>
            <RobotHand is_clicking={true} />
          </Fader>
        </Draggable>; 
      }
      else if (hand_substate === 4) {
        helping_hand = <Draggable 
          draggable={false} 
          initial_coords={stage_position}
          transition={movement_transition}
          on_transition_end={this.advance_hand}
        >
          <Fader visible={true}>
            <RobotHand is_clicking={false} />
          </Fader>
        </Draggable>; 
      }
      else if (hand_substate === 5) {
        // if we haven't moved robot yet
        if (robot_locations[hand_should_move_robot].area === PANEL) {
          const placeholder = {area: STAGE, index: hand_should_move_robot_to_stage_position};
          onNextFrame(() => this.click_placeholder(placeholder))
        }
        else {
          state_transition_timeout = <Timer
            delay={300}
            on_timeout={this.advance_hand}
            reset_prevention_key='make hand disappear'
          />
        }
        helping_hand = <Draggable 
          draggable={false} 
          initial_coords={stage_position}
        >
          <Fader visible={true}>
            <RobotHand is_clicking={true} />
          </Fader>
        </Draggable>;  
      }
      else if (hand_substate === 6) {
        helping_hand = <Draggable 
          draggable={false} 
          initial_coords={stage_position}
        >
          <Fader visible={false} on_transition_end={() => this.cancel_helping_hand()}>
            <RobotHand is_clicking={false} />
          </Fader>
        </Draggable>; 
      }
    }
    else if (hand_state === HELPING_HAND_STATES.PRESS_PLAY) {
      const play_position = getAppCoordinates(this.get_stage_control_button()).center;
      helping_hand = this.render_hand_moving_and_clicking(play_position);
    }
    
    const play_function = () => this.startLevel(level);

    return this.render_app({
      help_callback: help_callback,
      help_timeout: help_timeout,
      helping_hand: helping_hand,
      state_transition_timeout: state_transition_timeout,
      located_robots: located_robots,
      magnets_pulsing: selected_robot !== null,

      panel_place_holders: panel_indeces.map(panel_index => <PlaceHolder
        focus_child_ref_func={this.focusable_function(panel_focus_key(panel_index), FOCUS_ROWS.PANEL)}
        has_focus={this.shows_keyboard_focus() && focused_item_key === panel_focus_key(panel_index)}
        is_hovered={selected_placeholder && selected_placeholder.area === PANEL && selected_placeholder.index === panel_index}
        should_transition_to_current_color={false}
        on_select={() => this.select_placeholder_during_filling_stage({area: PANEL, index: panel_index})}
      />),

      stage_place_holders: level.stage_indeces.map(stage_index => <PlaceHolder
        focus_child_ref_func={this.stage_focus_function(stage_index)}
        has_focus={this.shows_keyboard_focus() && focused_item_key === stage_focus_key(stage_index)}
        is_hovered={selected_placeholder && selected_placeholder.area === STAGE && selected_placeholder.index === stage_index}
        should_transition_to_current_color={false}
        on_select={() => this.select_placeholder_during_filling_stage({area: STAGE, index: stage_index})}
      />),

      stage_controls: stage_is_full ? <StageControls
        button={STAGE_CONTROL_BUTTONS.PLAY}
        focus_ref={this.focusable_function('play_button', FOCUS_ROWS.PLAYBACK_CONTROLS)}
        has_focus={this.shows_keyboard_focus() && focused_item_key === 'play_button'}
        on_select={play_function}
      /> : null,
    });
  }

  render_playing() {
    const {playing_state, level_index, sequence_number, current_sequence, note_number, robot_locations} = this.state;
    const level = LEVELS[level_index];
    const active_robot_index = this.robot_for_stage_index(current_sequence[note_number - 1]);


    let playing_robot_index = null;
    let visually_singing_index = null;
    let should_transition_to_current_color = true;
    let state_transition_timeout = null;
    let progress_note_number = note_number;
    let on_sound_complete = () => {};

    switch (playing_state) {
      case PLAYING_STATES.PAUSED_BEFORE_STARTING_SEQUENCE:
        progress_note_number = 0;
        state_transition_timeout = <Timer
          delay={500}
          on_timeout={() => this.setState({
            playing_state: PLAYING_STATES.STARTING_NOTE,
          })}
          reset_prevention_key={"play_first_note"}
        />
        break;

      case PLAYING_STATES.STARTING_NOTE:
        should_transition_to_current_color = false;
        playing_robot_index = active_robot_index;
        visually_singing_index = active_robot_index;
        on_sound_complete = () => this.setState({
          playing_state: PLAYING_STATES.ENDING_NOTE,
        });
        // onNextFrame(() => this.setState({
        //   playing_state: PLAYING_STATES.ENDING_NOTE,
        // }));
        break;

      case PLAYING_STATES.ENDING_NOTE:
        // visually_singing_index = active_robot_index;

        if (note_number < current_sequence.length) {
          state_transition_timeout = <Timer 
            delay={200}
            on_timeout={() => this.setState({
              playing_state: PLAYING_STATES.STARTING_NOTE,
              note_number: note_number + 1,
            })}
            reset_prevention_key={"play_note_after_" + note_number}
          />;
        }
        else {
          state_transition_timeout = <Timer 
            delay={200}
            on_timeout={() => this.setState({
              game_state: GAME_STATES.REPEATING_SEQUENCE,
              note_number: 1,
              repeating_state: REPEATING_STATES.WAITING_FOR_INPUT,
            })}
            reset_prevention_key={"go_to_repeating"}
          />;
        }
        break;

      default:
        break;
    }

    return this.render_app({
      state_transition_timeout: state_transition_timeout,
      progress_bar: <ProgressBar
        level={level_index}
        current_playback_length={progress_note_number}
      />,
      robots: robot_indeces.map(robot_index => <Robot
        number={robot_index+1}
        should_play_sound_once={robot_index === playing_robot_index}
        on_sound_complete={on_sound_complete}
        visual_state={robot_index === visually_singing_index ? ROBOT_VISUAL_STATES.SINGING : ROBOT_VISUAL_STATES.DEFAULT}
        large={robot_locations[robot_index].area === STAGE}
      />),
      panel_place_holders: panel_indeces.map(panel_index => <PlaceHolder
        key={panel_index}
      />),
      stage_place_holders: level.stage_indeces.map(stage_index => <PlaceHolder
        key={stage_index}
        should_transition_to_current_color={should_transition_to_current_color}
      />),   
    });
  }

  render_repeating() {
    const {
      repeating_state, 
      level_index, 
      sequence_number, 
      current_sequence, 
      note_number, 
      robot_locations,
      focused_item_key,
      hand_state,
    } = this.state;
    const level = LEVELS[level_index];
    const stage_locations = stage_locations_by_level[level_index];

    let help_callback = null;
    if (hand_state === HELPING_HAND_STATES.AVAILABLE) {
      help_callback = () => this.setState({
        hand_state: HELPING_HAND_STATES.TAP_CORRECT_ROBOT,
        hand_substate: 0,
      });
    }

    let help_timeout = null;
    if (hand_state === HELPING_HAND_STATES.NONE) {
      if (repeating_state === REPEATING_STATES.WAITING_FOR_INPUT) {
        help_timeout = this.create_help_timer("tap_correct_robot");
      }
    }

    let helping_hand = null;
    if (hand_state !== HELPING_HAND_STATES.NONE && hand_state !== HELPING_HAND_STATES.AVAILABLE) {
      const final_position = stage_locations[this.expectedStageIndex()].center;
      helping_hand = this.render_hand_moving_and_clicking(final_position); 
    }

    let visually_singing_index = null;
    if (repeating_state === REPEATING_STATES.INDICATING_SUCCESS || repeating_state === REPEATING_STATES.STARTING_NOTE) {
      visually_singing_index = this.robot_for_stage_index(current_sequence[note_number-1]);
    }

    let singing_index = null;
    if (repeating_state === REPEATING_STATES.STARTING_NOTE) {
      singing_index = this.robot_for_stage_index(current_sequence[note_number-1]);
    }

    if (repeating_state === REPEATING_STATES.STARTING_NOTE) {
      onNextFrame(() => this.setState({
        repeating_state: REPEATING_STATES.INDICATING_SUCCESS,
      }));
    }

    let on_sound_complete = null;
    if (repeating_state === REPEATING_STATES.INDICATING_SUCCESS) {
      if (note_number === current_sequence.length) {
        on_sound_complete = () => this.setState({
          game_state: GAME_STATES.SEQUENCE_SUCCESS,
        });
      }
      else {
        on_sound_complete = () => this.setState({
          repeating_state: REPEATING_STATES.WAITING_FOR_INPUT,
          note_number: note_number+1,
        });
      }
    }

    let on_stage_select = () => {};
    if (repeating_state === REPEATING_STATES.WAITING_FOR_INPUT) {
      const expected_index = current_sequence[note_number-1];
      on_stage_select = (index) => {
        this.cancel_any_available_help();
        if (index === expected_index) {
          this.setState({
            repeating_state: REPEATING_STATES.STARTING_NOTE,
          });
        }
        else {
          this.setState({
            game_state: GAME_STATES.FAILURE,
          })
        }
      }
    }
    if (repeating_state === REPEATING_STATES.INDICATING_SUCCESS && note_number < current_sequence.length) {
      const expected_index = current_sequence[note_number];
      on_stage_select = (index) => {
        this.cancel_any_available_help();
        if (index === expected_index) {
          this.setState({
            repeating_state: REPEATING_STATES.STARTING_NOTE,
            note_number: note_number+1,
          });
        }
        else {
          this.setState({
            game_state: GAME_STATES.FAILURE,
          })
        }
      }
    }

    const progress_bar_success_length = (repeating_state == REPEATING_STATES.WAITING_FOR_INPUT) ? note_number-1 : note_number;

    return this.render_app({
      help_callback: help_callback,
      helping_hand: helping_hand,
      help_timeout: help_timeout,
      show_stage_question_mark: true,
      progress_bar: <ProgressBar 
        level={level_index}
        current_input_length={progress_bar_success_length}
      />,
      robots: robot_indeces.map(robot_index => <Robot
        number={robot_index+1}
        should_play_sound_once={robot_index === singing_index}
        visual_state={robot_index === visually_singing_index ? ROBOT_VISUAL_STATES.SUCCESS : ROBOT_VISUAL_STATES.DEFAULT}
        on_sound_complete={robot_index === visually_singing_index ? on_sound_complete : null}
        large={robot_locations[robot_index].area === STAGE}
        shaking={robot_locations[robot_index].area === STAGE}
      />),
      panel_place_holders: panel_indeces.map(panel_index => <PlaceHolder
        key={panel_index}
      />),
      stage_place_holders: level.stage_indeces.map(stage_index => <PlaceHolder
        key={stage_index}
        focus_child_ref_func={this.stage_focus_function(stage_index)}
        has_focus={this.shows_keyboard_focus() && focused_item_key === stage_focus_key(stage_index)}
        on_select={on_stage_select.bind(null, stage_index)}
      />),
    });
  }

  render_sequence_success() {
    const {sequence_number, level_index, current_sequence, note_number} = this.state;
    const level = LEVELS[level_index];

    let state_transition_timeout = null;

    if (sequence_number === level.notes_per_sequence.length) {
      // go immediately to level success
      // The current state isn't strictly necessary, but the logic is made a lot simpler by including it.
      // TODO - is this a race condition? What if user clicks level change button before this fires? (which is essentially impossible)
      // Maybe onNextFrame should be refactored
      onNextFrame(() => this.setState({
        game_state: GAME_STATES.LEVEL_SUCCESS,
      }));
    }
    else {
      // Nothing special in this state. Just a wait a little bit before going to next sequence.
      // Maybe we'll want to play a sound in this state.
      state_transition_timeout = <Timer
        delay={0}
        on_timeout={() => this.startSequence(level, current_sequence, sequence_number + 1)}
        reset_prevention_key="go_to_next_sequence"
      />
    }

    return this.render_app({
      state_transition_timeout: state_transition_timeout,
      progress_bar: <ProgressBar 
        level={level_index}
        current_input_length={0}
      />,
      robots: this.getBasicRobots(),
      panel_place_holders: panel_indeces.map(panel_index => <PlaceHolder
        key={panel_index}
        should_transition_to_current_color={false}
      />),
      stage_place_holders: level.stage_indeces.map(stage_index => <PlaceHolder
        key={stage_index}
      />),
    });
  }

  render_failure() {
    const {level_index, focused_item_key, hand_state} = this.state;
    const level = LEVELS[level_index];

    const reset = () => {
      this.setState({
        game_state: GAME_STATES.FILLING_STAGE,
      });
      this.cancel_any_available_help();
    };

    let help_callback = null;
    let helping_hand = null;
    let help_timeout = null;

    if (hand_state === HELPING_HAND_STATES.NONE) {
      help_timeout = this.create_help_timer("tap reset button");

    }
    else if (hand_state === HELPING_HAND_STATES.AVAILABLE) {
      help_callback = () => this.setState({
        hand_state: HELPING_HAND_STATES.TAP_RESET_BUTTON,
        hand_substate: 0,
      });
    }
    else {
      const final_position = getAppCoordinates(this.get_stage_control_button()).center;
      helping_hand = this.render_hand_moving_and_clicking(final_position);
    }

    return this.render_app({
      help_timeout: help_timeout,
      help_callback: help_callback,
      helping_hand: helping_hand,
      robots: this.getBasicRobots(true),

      panel_place_holders: panel_indeces.map(panel_index => <PlaceHolder
        key={panel_index}
        is_error={true}
      />),

      stage_place_holders: level.stage_indeces.map(stage_index => <PlaceHolder
        key={stage_index}
        is_error={true}
      />),

      stage_controls: <StageControls
        button={STAGE_CONTROL_BUTTONS.RESET}
        focus_ref={this.focusable_function('play_button', FOCUS_ROWS.PLAYBACK_CONTROLS)}
        has_focus={this.shows_keyboard_focus() && focused_item_key === 'play_button'}
        on_select={reset}
      />,
    });
  }

  render_level_success() {
    const {level_index, robot_locations, focused_item_key, hand_state} = this.state;
    const level = LEVELS[level_index];

    const reset = () => {
      this.setState({
        game_state: GAME_STATES.FILLING_STAGE

      });
      this.cancel_any_available_help();
    }

    let help_callback = null;
    let helping_hand = null;
    let help_timeout = null;
    if (hand_state === HELPING_HAND_STATES.NONE) {
      if (level_index < LEVELS.length-1) {
        help_timeout = this.create_help_timer("tap next level");
      }
    }
    else if (hand_state === HELPING_HAND_STATES.AVAILABLE) {
      help_callback = () => this.setState({
        hand_state: HELPING_HAND_STATES.TAP_NEXT_LEVEL,
        hand_substate: 0,
      });
    }
    else {
      const button_top_corner = level_button_positions[level_index + 1];
      const final_position = {
        left: button_top_corner.left + LEVEL_BUTTON_WIDTH/2,
        top: button_top_corner.top + LEVEL_BUTTON_HEIGHT/2,
      };
      helping_hand = this.render_hand_moving_and_clicking(final_position);
    }

    return this.render_app({
      help_timeout: help_timeout,
      help_callback: help_callback,
      helping_hand: helping_hand,
      progress_bar: <ProgressBar 
        level={level_index}
        current_input_length={level.max_sequence_length}
      />,
      robots: robot_indeces.map(robot_index => <Robot
        number={robot_index+1}
        large={robot_locations[robot_index].area === STAGE}
        visual_state={ROBOT_VISUAL_STATES.SINGING}
      />),
      panel_place_holders: panel_indeces.map(panel_index => <PlaceHolder
        key={panel_index}
        is_playing={true}
        should_transition_to_current_color={false}
      />),
      stage_place_holders: level.stage_indeces.map(stage_index => <PlaceHolder
        key={stage_index}
        is_playing={true}
        should_transition_to_current_color={false}
      />),
      stage_controls: <StageControls
        button={STAGE_CONTROL_BUTTONS.RESET}
        focus_ref={this.focusable_function('play_button', FOCUS_ROWS.PLAYBACK_CONTROLS)}
        has_focus={this.shows_keyboard_focus() && focused_item_key === 'play_button'}
        on_select={reset}
      />
    });
  }
  get_spotlight() {
    const {game_state} = this.state;
    let class_name = 'App-layer App-spotlight';
    if (game_state != GAME_STATES.PLAYING_SEQUENCE) {
      class_name += ' App-spotlight-off';
    }
    return <img src={spotlight} alt="" className={class_name} />
  }
  get_keyboard_hints() {
    const {hand_state} = this.state;
    const visible = hand_state === HELPING_HAND_STATES.AVAILABLE;
    return <KeyboardHints visible={visible} />
  }
  get_success_layer() {
    const {game_state} = this.state;
    let visible = false;
    let success = false;
    switch (game_state) {
      case GAME_STATES.LEVEL_SUCCESS :
        success = true;
        visible = true;
        break;
      case GAME_STATES.FAILURE :
        visible = true;
    }
    return <SuccessLayer visible={visible} success={success} />
  }

  render_app({
    robots=null, 
    located_robots=null, 
    panel_place_holders, 
    stage_place_holders,
    stage_controls=null,
    progress_bar=null,
    helping_hand=null,
    help_timeout=null,
    help_callback=null,
    /*
      This parameter should be a Timer instance. Use to schedule general state transitions.
      We could probably merge this parameter with the help_timeout (since we'll
      probably never use both in the same state), but they are logically different, so it 
      makes some sense to separate them.
    */
    state_transition_timeout=null,
    show_stage_question_mark=false,
    magnets_pulsing=false,
  }) {
    const {
      level_index,
      hand_timeout_counter,
      focused_item_key,
      muted,
      game_state,
    } = this.state;

    window.createjs.Sound.muted = muted;

    const stage_locations = stage_locations_by_level[level_index];

    if (!stage_controls) {
      // must be rendered every time (for transitions to work)
      // renders off-screen by default
      stage_controls = <StageControls />
    }

    if (robots !== null && located_robots === null) {
      located_robots = robot_indeces.map(robot_index => <Draggable
        key={robot_index}
        draggable={false}
        initial_coords={this.getCoordinatesOfRobotPlaceHolder(robot_index)}
      >
        <ZeroSizeCenterer>
          {robots[robot_index]}
        </ZeroSizeCenterer>
      </Draggable>);
    }

    if (progress_bar === null) {
      progress_bar = <ProgressBar 
        level={level_index}
      />;
    }

    const mute_change = () => this.setState({muted: !muted});

    return (
      <div className="App" ref={(app) => {this.app_element = app}}>
        <img src={background_layer} style={{position: 'absolute', left: 0, top: 0,}} alt="" />
        <img src={panel_layer} style={{position: 'absolute', left: 0, top: 0,}} alt="" />
        <img src={control_bar_layer} style={{position: 'absolute', left: 0, bottom: 0,}} alt="" />
        <img src={stage_images[level_index]} style={{position: 'absolute', left: 0, top: 0}} alt="" />

        <MagnetStrobeLayer
          level_index={level_index}
          pulsing={magnets_pulsing}
        />

        {/* this is just the image - not the interactive button */}
        <img src={active_level_buttons[level_index]} style={{position: 'absolute', left: 0, bottom: 0}} alt="" />

        {progress_bar}
        
        <MuteButton 
          focus_ref={this.focusable_function('volume_button', FOCUS_ROWS.MUTE_CONTROLS)}
          has_focus={this.shows_keyboard_focus() && focused_item_key === 'volume_button'}
          on_select={mute_change}
          currently_muted={muted}
        />

        {help_callback !== null ? <HelpButton
          visible={true}
          focus_ref={this.focusable_function('help_button', FOCUS_ROWS.HELP_BUTTON)}
          has_focus={this.shows_keyboard_focus() && focused_item_key === 'help_button'}
          on_select={help_callback}
        /> : <HelpButton visible={false} />}
        {stage_controls}

        <div id="App-panel-placeholders">
          {panel_place_holders.map((place_holder, index) => <div key={index} style={{
            position: 'absolute',
            top: panel_locations[index].upper_left.top,
            left: panel_locations[index].upper_left.left,
            width: panel_place_holder_half_width*2,
            height: panel_place_holder_half_width*2,
          }}>
            {place_holder}
          </div>)}
        </div>
        <div id="App-stage-placeholders">
          {stage_place_holders.map((place_holder, index) => <div key={index} style={{
            position: 'absolute',
            top: stage_locations[index].upper_left.top,
            left: stage_locations[index].upper_left.left,
            width: stage_place_holder_half_width*2,
            height: stage_place_holder_half_width*2,
          }}>
            {place_holder}
          </div>)}
        </div>

        {/* 
        <div className="App-stage-container">
          <img 
            className={classnames("App-stage-question-mark", {"App-stage-question-mark-visible": show_stage_question_mark})}
            src={question_mark_svg} 
            alt="Which robot is the next one in the sequence?" 
          />

          <div className="App-stage-controls-container" ref={(div) => {this.stage_control_container = div;}}>
            {stage_controls}
          </div>
        </div>
        */}

        {BUTTON_INDECES.map((button_index) => {
          const active = button_index === level_index;
          const listener = active ? null : () => this.setState({
            hand_timeout_counter: hand_timeout_counter + 1,
            level_index: button_index,
            robot_locations: this.robotLocationsUpdatedForLevel(button_index),
            game_state: GAME_STATES.FILLING_STAGE,
          });
          return <InvisibleButton
            key={button_index}
            focus_ref={this.focusable_function(level_control_key(button_index), FOCUS_ROWS.LEVEL_CONTROLS)}
            has_focus={this.shows_keyboard_focus() && focused_item_key === level_control_key(button_index)}
            on_select={listener}
            width={LEVEL_BUTTON_WIDTH}
            height={LEVEL_BUTTON_HEIGHT}
            left={level_button_positions[button_index].left}
            top={level_button_positions[button_index].top}
          />
        })}
        
        {/* Robot do not receive touch events! */}
        <div className="App-layer" style={{pointerEvents: 'none'}}>
          {located_robots}
        </div>

        {this.get_spotlight()}
        {this.get_success_layer()}
        {this.get_keyboard_hints()}
        
        {helping_hand}
        {DISABLE_HAND ? null : help_timeout}
        {state_transition_timeout}

        {helping_hand ? (
          // add full-screen overlay to intercept touch events and prevent default actions
          <div className="App-layer" />
        ) : null}
      </div>
    );
  }

  render() {
    const {game_state} = this.state;

    switch (game_state) {
      case GAME_STATES.FILLING_STAGE:
        return this.render_filling();

      case GAME_STATES.PLAYING_SEQUENCE:
        return this.render_playing();   

      case GAME_STATES.REPEATING_SEQUENCE:
        return this.render_repeating();

      case GAME_STATES.SEQUENCE_SUCCESS:
        return this.render_sequence_success();

      case GAME_STATES.LEVEL_SUCCESS:
        return this.render_level_success();

      case GAME_STATES.FAILURE:
        return this.render_failure();

      default:
        return null;
    }
  }
}
export default App;



// WEBPACK FOOTER //
// ./src/App.js